// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const politoed: PokeData = {
  "id": 186,
  "name": "politoed",
  "height": 11,
  "weight": 339,
  "base_experience": 225,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "pound",
    "double-slap",
    "body-slam",
    "double-edge",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "hypnosis",
    "belly-drum",
    "perish-song",
    "swagger",
    "rain-dance",
    "hyper-voice",
    "bounce",
    "mud-shot",
    "earth-power"
  ],
  "moves": [
    "body-slam",
    "hydro-pump",
    "bubble-beam",
    "rain-dance",
    "hyper-voice",
    "mud-shot",
    "earth-power",
    "aqua-tail",
    "aqua-cutter",
    "water-spout",
    "brine",
    "whirlpool",
    "life-dew"
  ],
  "evolution_chain": {
    "id": 26,
    "item": null,
    "species": [
      {
        "name": "poliwag",
        "order": 65,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "poliwhirl",
        "order": 66,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 60,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "poliwrath",
        "order": 67,
        "types": [
          PokeType.WATER,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 61,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "politoed",
        "order": 68,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 61,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 143,
    "speed": 113,
    "ability_power": 145
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
